import { DynamicHTMLEditorComponent } from '@peerless/data-access/strapi';
import { withSectionLayout } from './SectionLayout';
import { Stack } from '@mui/material';
import { SectionHeader } from './SectionHeader';
import { CallToActionSection } from './CallToActionSection';

interface Props {
  data: DynamicHTMLEditorComponent;
}

function WYSIWYGEditorImpl({ data }: Props) {
  const { callToAction, sectionHeader } = data;
  return (
    <Stack gap={4}>
      <SectionHeader {...sectionHeader} />
      <div dangerouslySetInnerHTML={{ __html: data.htmlText }} />
      <CallToActionSection callToAction={callToAction} />
    </Stack>
  );
}

export const WYSIWYGEditor = withSectionLayout(WYSIWYGEditorImpl);
